"use client";
import LoaderModal from "@/app/[locale]/checkout-process-deal/components/CheckoutLoader";
import React from "react";

import { useLoaderStore } from "../../../store/useLoader";

const Loader: React.FC = () => {
  const isLoading = useLoaderStore((state) => state.isLoading);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black bg-opacity-50">
      <LoaderModal />
    </div>
  );
};

export default Loader;
